import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import ChangeGrid from './ChangeGrid.js';

/**
 * StickyBar class.
 */
export default class StickyBar extends withBreakpointObserver(Base) {
  static config = {
    name: 'StickyBar',
    components: {
      ChangeGrid,
    },
    options: {
      activeBreakpoint: {
        default: 'xxs xs s',
        type: String,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.getSizes();
  }

  /**
   *
   */
  updated() {
    this.getSizes();
  }

  /**
   *
   */
  getSizes() {
    const rect = this.$parent.$refs.container.getBoundingClientRect();
    this.containerBottom = rect.bottom + window.scrollY;
    this.viewportMiddle = window.innerHeight / 2;
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   */
  scrolled({ y }) {
    if (this.containerBottom - this.viewportMiddle < y) {
      this.$el.classList.add('translate-y-full');
    } else {
      this.$el.classList.remove('translate-y-full');
    }
  }
}
